// Shared API base-URL constant. Single source of truth — previously
// duplicated across many files. Normalizing avoids double `/api` segments
// when an environment sets `REACT_APP_BACKEND_URL` to include it already.
const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
export const BACKEND_URL = rawBackendUrl;
export const API = rawBackendUrl.endsWith('/api') ? rawBackendUrl : `${rawBackendUrl}/api`;
